import { formatTime } from "../../../utils/timeConversion";
import { getVoyageNumber } from "../../../utils/domainSelectors";
import { formatTankReferences } from "../../../utils/tankReferences";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

const formatLocalTime = (value, is24Hour) => {
  if (!value) return "-";
  const [date, time = ""] = value.split("T");
  return `${date} ${time ? formatTime(time.slice(0, 5), is24Hour) : ""}`.trim();
};

export const createPumpLogPrintViewModelV2 = ({ currentVoyage, selectedTripId, selectedCargoIndex, isLoadLog, companyLogo, is24Hour }) => {
  const trip = getSelectedTrip(currentVoyage, selectedTripId);
  const cargo = getSelectedCargo(currentVoyage, selectedTripId, selectedCargoIndex);
  if (!trip || !cargo) throw new Error("Please select a cargo before printing.");
  const log = isLoadLog ? cargo.loadingLog : cargo.dischargingLog;
  const rates = isLoadLog ? cargo.loadingLogRates : cargo.dischargingLogRates;
  return {
    title: isLoadLog ? "Loading Log" : "Discharge Log", companyLogo: companyLogo || "", vesselName: currentVoyage?.vessel || "-", voyageNumber: getVoyageNumber(currentVoyage) || "-", cargoName: cargo.cargo || "-", date: trip.date || "-", port: trip.from || "-", berth: trip.jetty || "-", chiefOfficer: trip.crew?.chiefOfficer || "-", manifolds: rates?.manifolds || "-", connectionSize: rates?.connectionSize || "-",
    entries: Array.isArray(log) ? log.map((entry) => ({ localTime: formatLocalTime(entry.localTime, is24Hour), obq: entry.obq || "", rate: entry.rate ?? "", tanks: Array.isArray(entry.tanksNo) ? formatTankReferences(entry.tanksNo) : "", manifPress: entry.manifPress || "", sf: entry.sf || "", bm: entry.bm || "", remarks: entry.remarks || "" })) : [],
  };
};
